import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { RootState, useAppDispatch } from '../../../store/store';
import { undo } from '../../../store/slices/imageSlice';
import { selectActiveEditorMode } from '../../../store/selectors/pageSelectors';
import { quillRef } from '../../../store/ref/quillRef';
import IconUndo from '../icons/IconUndo';
import s from './UndoButton.module.css';

const UndoButton = () => {
    const historyLen = useSelector((s: RootState) => s.image.history.length);
    const activeEditorMode = useSelector(selectActiveEditorMode);
    const dispatch = useAppDispatch();

    const canUndo = activeEditorMode === 'Captions' ? true : historyLen > 1;

    const handleUndo = useCallback(() => {
        if (!canUndo) return;

        if (activeEditorMode === 'Visual') {
            dispatch(undo());
        } else if (activeEditorMode === 'Captions') {
            const editor = quillRef.current?.getEditor();
            const historyModule = editor?.getModule('history');
            if (historyModule?.stack?.undo?.length > 1) {
                historyModule.undo();
            }
        }
    }, [activeEditorMode, canUndo, dispatch]);

    if (!window.location.pathname.includes('/custom-post')) {
        return null;
    }

    if (!['Captions', 'Visual'].includes(activeEditorMode)) {
        return null;
    }

    return (
        <button
            type="button"
            className={s.undoButton}
            disabled={!canUndo}
            onClick={handleUndo}
            title={canUndo ? 'Undo (Ctrl/Cmd+Z)' : 'Nothing to undo'}
            aria-disabled={!canUndo}
        >
            <span className={s.iconWrap}>
                <IconUndo />
            </span>
            <span>Undo</span>
        </button>
    );
};

export default UndoButton;
